// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1FlBI","signatureBlock":"Footer_signatureBlock__3pIkj","signature":"Footer_signature__1lFpI"};